<template>
  <div>
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            lg="6"
            md="6"
          >
            <v-row>
              <v-col cols="12" lg="5" md="5" class="pt-0 pb-0 pr-24px">
                <v-text-field
                  v-model="srcStCd"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyStCd')"
                  @keyup.enter="searchByStCd"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="5" md="5" class="pt-0 pb-0">
                <v-text-field
                  v-model="srcDesc"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyDesc')"
                  @keyup.enter="searchByStDesc"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="2" class="pt-0 pb-0 pr-24px">
                <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
                  <v-btn
                    class="btn btn-top btn-search btn-width-1"
                    color="primary"
                    @click="searchData"
                  >
                    <v-icon x-small class="mr-1">fa fa-search</v-icon>
                    {{ $t('btn.common.search') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  class="btn-top-table btn-add"
                  @click="openAddSiteCode(null, 'Add')"
                  :disabled="!$auth.manage"
                  >{{ $t('btn.common.add') }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="30"
                  hide-details
                  dense
                  solo
                  @change="searchByFilter"
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  heigth="30"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  @input="searchByFilter"
                  @click:append="searchByFilter"
                  v-on:keyup.enter="searchByFilter"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="[
            'list-table text-center-table srm-list-table custom-border-table',
            listData.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          :footer-props="{
            showFirstLastPage: true,
          }"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          @click:row="rowClick"
          item-key="ROWID"
          single-select
        >
          <template v-slot:item.delete="{ item }">
            <v-btn @click="deleteKey(item)" small text icon :disabled="!$auth.manage">
              <icon-svg :disabled="!$auth.manage" iconName="delete" />
            </v-btn>
            <dialogWindow
              ref="DeleteSiteCode"
              size="max"
              title="Delete Site Code"
              :info="itemDelete.SITE_CODE"
              :detail="$t('msg.codes.deleteDvrtSiteCd')"
              :dataValue="itemDelete"
              color="confirmation"
              :showCancel="true"
              @select-ok="deleteItem(itemDelete)"
            ></dialogWindow>
          </template>
          <template v-slot:item.SITE_CODE="{ item }">
            <font class="col-id">{{ item.SITE_CODE }}</font>
          </template>
          <template v-slot:item.SITE_UPD_DT="{ item }">
            <font v-if="item.SITE_UPD_DT !== undefined">{{
              applyDateFormat(item.SITE_UPD_DT)
            }}</font>
          </template>

          <template v-slot:item.SITE_CODE="props">
            <font v-if="!$auth.manage" class="message-code">{{ props.item.SITE_CODE }}</font>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.SITE_CODE"
              large
              persistent
              @save="saveProps(props.item)"
            >
              <font class="message-code">{{ props.item.SITE_CODE }}</font>
              <template v-slot:input>
                <div class="mt-2">Update Site Code</div>
                <v-text-field
                  v-model="props.item.SITE_CODE"
                  :rules="[max25chars]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:item.SITE_NAME="props">
            <div v-if="!$auth.manage">{{ props.item.SITE_NAME }}</div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.SITE_NAME"
              large
              persistent
              @save="saveProps(props.item)"
            >
              <div>{{ props.item.SITE_NAME }}</div>
              <template v-slot:input>
                <div class="mt-2">Update Site Description</div>
                <v-text-field
                  v-model="props.item.SITE_NAME"
                  :rules="[max100chars]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:item.SITE_CUST_ID="props">
            <div v-if="!$auth.manage">{{ props.item.SITE_CUST_ID }}</div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.SITE_CUST_ID"
              large
              persistent
              @save="saveProps(props.item)"
            >
              <div>{{ props.item.SITE_CUST_ID }}</div>
              <template v-slot:input>
                <div class="mt-2">Update Site Company ID</div>
                <v-text-field
                  v-model="props.item.SITE_CUST_ID"
                  :rules="[max100chars]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:item.SITE_DB_PATH="props">
            <div v-if="!$auth.manage">{{ props.item.SITE_DB_PATH }}</div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.SITE_DB_PATH"
              large
              persistent
              @save="saveProps(props.item)"
            >
              <div>{{ props.item.SITE_DB_PATH }}</div>
              <template v-slot:input>
                <div class="mt-2">Update Site DB Path</div>
                <v-text-field
                  v-model="props.item.SITE_DB_PATH"
                  :rules="[max100chars]"
                  label="Edit"
                  single-line
                  counter
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </v-data-table>
        <v-snackbar v-model="snack" :timeout="1000" :color="snackColor">
          {{ snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
    <v-row v-show="listData.length > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label
                    >{{ itemsPerPage * (page - 1) + 1 }} ~
                    {{
                      listData.length - itemsPerPage * page > 0
                        ? itemsPerPage * page
                        : listData.length
                    }}
                    of {{ listData.length }}</v-label
                  >
                </div>
                <button
                  type="button"
                  @click="page = 1"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-backward"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-left"></i>
                    </span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field>
                <label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-right"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="page = pageCount"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : $vuetify.theme.dark
                      ? ''
                      : 'white',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-forward"></i>
                    </span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="deletedDialog"
      size="max"
      :title="checkDialogTitle"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
    ></dialogWindow>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <add-identificationin-dialog
        v-if="dialog.type == 'addSiteCode'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :indexType="editedIndex"
        :refeshList="searchData"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></add-identificationin-dialog>
    </div>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import addIdentificationinDialog from '@/vue-caas/views/codes/AddDeliverySiteCode.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    dialogWindow,
    addIdentificationinDialog,
    SystemProgress,
    IconSvg,
  },
  props: {},

  data() {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      max50chars: (v) => v.length <= 50 || 'Input too long!',
      max100chars: (v) => v.length <= 100 || 'Input too long!',
      tableHeight: '',
      isCreated: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      pageEnter: 1, // 2021.11.25 203728 SPKA-274 modify paging
      searchBy: 'all',
      searchByTxt: '',
      detailDialog: false,
      srcDesc: '',
      srcStCd: '',
      srcPrnrId: '',
      listData: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialogs: [],
      editedIndex: -1,
      editedItem: {
        srId: '',
        compId: '',
        remark: '',
      },
      item: null,
      itemDelete: {},
      inputDisplay: 'd-none',
      checkDialog: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      checkDialogTitle: 'Alert',
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Site Code', value: 'SITE_CODE' },
        { text: 'Site Description', value: 'SITE_NAME' },
        { text: 'Site Company ID', value: 'SITE_CUST_ID' },
        { text: 'Site DB Path', value: 'SITE_DB_PATH' },
      ],
      EDIMesList: [{ text: 'Select Site Code', value: '' }],
      EDIMesCdList: [{ text: 'Select Site Code', value: '' }],
      headers: [
        { text: 'Site Code', value: 'SITE_CODE', width: '200' },
        { text: 'Site Description', value: 'SITE_NAME' },
        { text: 'Site Company ID', value: 'SITE_CUST_ID', width: '250' },
        { text: 'Site DB Path', value: 'SITE_DB_PATH', width: '200' },
        {
          text: 'Update User',
          value: 'SITE_UPD_USR',
          align: 'center',
          width: '250',
        },
        {
          text: 'Last Update',
          value: 'SITE_UPD_DT',
          align: 'center',
          width: '150',
        },
        {
          text: 'Delete',
          value: 'delete',
          align: 'center',
          width: '100',
          sortable: false,
        },
      ],
      allCodeItems: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      modifyDataItems: {
        header: ['SITE_CODE', 'SITE_NAME', 'SITE_CUST_ID', 'SITE_DB_PATH'],
        data: [],
      },
      deleteDataItems: {
        header: ['SITE_CODE'],
        data: [],
      },
      isLoading: true,
      selectedId: -1,
    };
  },

  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },

  watch: {
    page() {
      this.pageEnter = this.page;
    },
  },

  methods: {
    rowClick: function(item, row) {
      row.select(true);
      this.selectedId = item.ROWID;
    },
    deleteKey(item) {
      this.itemDelete = item;
      this.$refs.DeleteSiteCode.dialog = true;
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    searchData() {
      this.isLoading = true;
      this.allCodeItems.data[0].CUST_ID = this.$cookies.get('comp-id');
      this.$store
        .dispatch('getSiteCodeList', this.allCodeItems)
        .then(() => {
          this.listData = this.$store.getters.stCdList;

          this.page = 1;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    searchByFilter(str) {
      this.$store.commit('SET_STORE_STCD_LIST_FILTER', {
        filter: this.searchBy,
        str: this.searchByTxt,
      });
      this.listData = this.$store.getters.stCdList;
    },

    searchByStCd(str) {
      this.$store.commit('SET_STORE_STCD_LIST_FILTER', {
        filter: `SITE_CODE`,
        str: this.srcStCd,
      });
      this.listData = this.$store.getters.stCdList;

      if (this.srcStCd === '' && this.srcDesc !== '') {
        this.searchByStDesc();
      }
    },

    searchByStDesc(str) {
      this.$store.commit('SET_STORE_STCD_LIST_FILTER', {
        filter: `SITE_NAME`,
        str: this.srcDesc,
      });
      this.listData = this.$store.getters.stCdList;

      if (this.srcStCd !== '' && this.srcDesc === '') {
        this.searchByStCd();
      }
    },

    openAddSiteCode(itemRow, typeActive) {
      let isEdit = false;

      this.editedIndex = -1;
      isEdit = false;

      let type = 'addSiteCode';
      let item = {
        ROWID: 0,
        isEdit: isEdit,
      };
      let indexArrDialog = this.findDialog('addSiteCode_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },

    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },

    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },

    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },

    applyDateFormat(date) {
      const data = date ? new Date(date) : new Date();
      return data.toFormat('YYYY-MM-DD HH24:MI:SS');
    },

    saveProps(item) {
      this.modifyDataItems.data[0] = {
        SITE_CODE: item.SITE_CODE,
        SITE_CUST_ID: item.SITE_CUST_ID,
        SITE_NAME: item.SITE_NAME,
        SITE_DB_PATH: item.SITE_DB_PATH,
      };
      this.$store.dispatch('updateSiteCode', this.modifyDataItems).then(() => {
        this.searchData();
        this.snack = true;
        this.snackColor = 'success';
        this.snackText = 'Data saved';
      });
    },

    deleteItem(item) {
      this.deleteDataItems.data[0] = {
        SITE_CODE: item.SITE_CODE,
      };
      this.$store.dispatch('deleteSiteCode', this.deleteDataItems).then(() => {
        this.searchData();
        this.checkDialogColor = 'success';
        this.checkDialogInfo = this.$t('msg.codes.afterDeleteDvrtSiteCd');
        this.checkDialogTitle = 'Deleted Successfully';
        this.$refs.deletedDialog.dialog = true;
      });
    },
  },

  created() {
    this.searchData();
    this.isCreated = true;
  },

  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 59 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 59 + 'px';
    });
  },
};
</script>
